import { isUserHasRightsForElt } from 'legacy/lut/components/widgets/public/partner360/ELT'
import { useUserRoles } from 'legacy/lut/hooks/useUserRoles'

export const useCanDeleteCockpitEltDocument = (): boolean => {
  const { roles } = useUserRoles()

  return isUserHasRightsForElt(roles)
}
